import { LogRequest } from 'common/models/LogsRequest';
import { BehaviorSubject } from 'rxjs';

// Arrays to store logs
let infoLogs: string[] = [];
let errorLogs: string[] = [];

export const infoLogsChange$ = new BehaviorSubject<LogRequest>(null);
export const errorLogsChange$ = new BehaviorSubject<LogRequest>(null);

// Save the original functions
const originalLog = console.log;
const originalInfo = console.info;
const originalError = console.error;

type LogFunction = typeof console.log;

// Override console.info with a custom function
console.info = function (...args: unknown[]) {
  const logs = getLogsByArguments(args, originalInfo);

  infoLogs.push(logs.join(' '));
  infoLogsChange$.next(createLogRequest(infoLogs));
};

// Override console.log with a custom function
console.log = function (...args: unknown[]) {
  const logs = getLogsByArguments(args, originalLog);

  infoLogs.push(logs.join(' '));
  infoLogsChange$.next(createLogRequest(infoLogs));
};

// Override console.log with a custom function
console.error = function (...args: unknown[]) {
  const logs = getLogsByArguments(args, originalError);

  errorLogs.push(logs.join(' '));
  errorLogsChange$.next(createLogRequest(errorLogs));
};

function getLogsByArguments(
  argumentsParam: unknown[],
  originalConsole: LogFunction
): unknown[] {
  const logArguments = Array.from(argumentsParam);

  // Call the original function to output to console
  originalConsole.apply(console, logArguments);

  return logArguments.map((arg) =>
    typeof arg === 'object' ? JSON.stringify(arg) : arg
  );
}

export function createLogRequest(logs: string[]): LogRequest {
  return {
    Logs: logs,
  };
}

export function clearInfoLogs(): void {
  infoLogs = [];
}

export function clearErrorLogs(): void {
  errorLogs = [];
}

export function addToExistingInfoLogs(logs: string[]): void {
  infoLogs = [...logs, ...infoLogs];
}

export function addToExistingErrorLogs(logs: string[]): void {
  errorLogs = [...logs, ...errorLogs];
}
